/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LogLineDto } from '../models/LogLineDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LogControllerService {

    /**
     * @param name
     * @param level
     * @returns any OK
     * @throws ApiError
     */
    public static updateLogLevel(
        name: string,
        level: 'TRACE' | 'DEBUG' | 'INFO' | 'WARN' | 'ERROR',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/logs/{name}/{level}',
            path: {
                'name': name,
                'level': level,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param referenceTimestamp
     * @param prevLogs
     * @param numLogs
     * @param level
     * @param filter
     * @returns LogLineDto OK
     * @throws ApiError
     */
    public static printLogs(
        name: string,
        referenceTimestamp: string,
        prevLogs: boolean,
        numLogs: number,
        level: 'TRACE' | 'DEBUG' | 'INFO' | 'WARN' | 'ERROR',
        filter: string,
    ): CancelablePromise<Array<LogLineDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/logs/{name}',
            path: {
                'name': name,
            },
            query: {
                'referenceTimestamp': referenceTimestamp,
                'prevLogs': prevLogs,
                'numLogs': numLogs,
                'level': level,
                'filter': filter,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns string OK
     * @throws ApiError
     */
    public static printConsoleOutput(
        name: string,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/console/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
